import Vue from 'vue'
import Vuex from 'vuex'

import admin from './modules/admin'
import colors from './modules/colors'
import copy from './modules/copy'
import header from './modules/header'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import usuarios from './modules/usuarios'
import info from './modules/info'
import suscripciones from './modules/suscripciones'
import productos from './modules/productos'
import personalizacion from './modules/personalizacion'
import storeOnline from './modules/storeOnline'
import factura from './modules/factura'
import categories from './modules/categories'
import marcas from './modules/marcas'
import atributos from './modules/atributos'
import gallery from './modules/gallery'
import related from './modules/related'
import payment from './modules/payment'
import clientes from './modules/clientes'
import servicios from './modules/servicios'
import sociales from './modules/sociales'
import slides from './modules/slides'
import compras from './modules/compras'
import projectInfo from './modules/projectInfo'
import statistics from './modules/statistics'
import notas from './modules/notas'
import bloqueos from './modules/bloqueos'
import calendar from './modules/calendar'
import carrito from './modules/carrito'
import appointment from './modules/appointment'
import citas from './modules/citas'
import tendencias from './modules/tendencias'
import agenda from './modules/agenda'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    colors,
    copy,
    header,
    logo,
    main,
    mainmtr,
    usuarios,
    info,
    suscripciones,
    productos,
    personalizacion,
    storeOnline,
    factura,
    categories,
    marcas,
    atributos,
    gallery,
    related,
    payment,
    clientes,
    servicios,
    sociales,
    slides,
    compras,
    projectInfo,
    statistics,
    notas,
    bloqueos,
    calendar,
    carrito,
    appointment,
    citas,
    tendencias,
    agenda
  }
})
